module.exports = __webpack_public_path__ + "static/media/status_ok.4f4c90e5.svg";